import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { CartButton } from '@grandvisionhq/common';
import { FixedCta } from '@grandvisionhq/content';
import { PageLayout } from '@grandvisionhq/layout';
import { useFeatureToggles } from '@grandvisionhq/state';
import '../containers/Accordion/Accordion.js';
import '../containers/Article/Article.js';
import '../containers/ArticleCollection/ArticleCollection.js';
import '../containers/Banner/Banner.js';
import '../containers/BannerCollection/BannerCollection.js';
import '../containers/BlogCollection/BlogCollection.js';
import '../containers/BlogOverview/BlogOverview.js';
import '../containers/BrandCollection/BrandCollection.js';
import '../containers/BrandList/BrandList.js';
import '../containers/Carousel/Carousel.js';
import { CmsComponentSlot } from '../containers/Slot/Slot.js';
import '@bloomreach/react-sdk';
import '../context/configuration.js';
import '../containers/CountdownTimer/CountdownTimerDocument.js';
import '../containers/Iframe/Iframe.js';
import '../containers/LinkList/LinkList.js';
import '../containers/RecommendedProducts/RecommendedProducts.js';
import '../containers/RichText/RichTextDocument.js';
import '../containers/Video/Video.js';
import '../containers/Widget/Widget.js';
import '@grandvisionhq/elements';
import '@grandvisionhq/utils';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '../utils/http-client.js';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/graphql';
import '../operations/mutations/signup-promotion.js';
import '../operations/mutations/subscribe-newsletter.js';
import '../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import '../hooks/use-breakpoint-visibility.js';
import { useGetCtaButtonComponent } from '../hooks/use-get-cta-button-component.js';
import '../containers/CountdownTimer/CountdownTimer.js';
import '../containers/Document/Document.js';
import '../containers/Faq/Faq.js';
import { CmsFooter } from '../containers/Footer/Footer.js';
import '../containers/GroupedCards/GroupedCards.js';
import CmsHeader from '../containers/Header/Header.js';
import '../containers/Heading/Heading.js';
import '../containers/IconList/IconList.js';
import '../containers/Newsletter/Newsletter.js';
import '../containers/NewsletterBanner/NewsletterBanner.js';
import '../containers/TryInStoreBanner/TryInStoreBanner.js';
import '../containers/NotificationBar/NotificationBar.js';
import '../containers/Olapic/Olapic.js';
import '../containers/PolicyBar/PolicyBar.js';
import '@grandvisionhq/commercetools';
import '@grandvisionhq/products';
import '../containers/Breadcrumbs/Breadcrumbs.js';
import '../containers/ProductCatalog/ProductCatalog.js';
import '../containers/Promotion/Promotion.js';
import '../containers/RecentlyViewedProducts/RecentlyViewedProducts.js';
import '../containers/RichText/RichText.js';
import '../containers/Whitespace/Whitespace.js';
import '../containers/SpotlightedStores/SpotlightedStores.js';
import '../containers/FixedCta/FixedCta.js';
import '../containers/Button/Button.js';
import '../containers/GlobalContactForm/GlobalContactForm.js';
import 'classnames';
import '../containers/RowComponent/RowText/RowText.js';
import '../containers/RowComponent/RowProductListBySku/RowProductListBySku.js';

const defaultLayout = {
    header: true,
    footer: true,
    navigation: true,
    hasOnlyLogoInHeader: false
};
const CmsPageLayout = ({ children , layoutSettings ={} , renderCartButton =defaultRenderCartButton , renderWishlistMenuItem , useAlternativeLogoInFooter ,  })=>{
    const layout = swcHelpers.objectSpread({}, defaultLayout, layoutSettings);
    const { isWishlistEnabled  } = useFeatureToggles();
    const header = layout.header ? /*#__PURE__*/ React.createElement(CmsComponentSlot, {
        path: "header"
    }, /*#__PURE__*/ React.createElement(CmsHeader, {
        renderSiteNav: !layout.hasOnlyLogoInHeader && layout.navigation,
        hasOnlyLogo: layout.hasOnlyLogoInHeader,
        renderCartButton: renderCartButton,
        renderWishlistMenuItem: isWishlistEnabled ? renderWishlistMenuItem : undefined
    })) : null;
    // The pre-footer should only be rendered on pages that have a footer
    const preFooter = layout.footer ? /*#__PURE__*/ React.createElement(CmsComponentSlot, {
        path: "prefooter/shared-container"
    }) : null;
    const footer = layout.footer ? /*#__PURE__*/ React.createElement(CmsComponentSlot, {
        path: "footer"
    }, /*#__PURE__*/ React.createElement(CmsFooter, {
        useAlternativeLogoInFooter: useAlternativeLogoInFooter
    })) : null;
    const { contentBlock , color , variant  } = useGetCtaButtonComponent();
    // The post-footer-cta-button should only be rendered on pages that have the cta-button
    const fixedBottomBarContent = contentBlock ? /*#__PURE__*/ React.createElement(FixedCta, {
        buttonText: contentBlock.buttonText,
        color: color !== null && color !== void 0 ? color : 'primary',
        variant: variant !== null && variant !== void 0 ? variant : 'solid',
        newWindow: contentBlock.newWindow,
        icon: contentBlock.iconImage,
        url: contentBlock.url,
        description: contentBlock.description
    }) : null;
    return /*#__PURE__*/ React.createElement(PageLayout, {
        header: header,
        footer: footer,
        preFooter: preFooter,
        fixedBottomBarContent: fixedBottomBarContent,
        hasSiteNav: layout.navigation,
        hasOnlyLogoInHeader: layout.hasOnlyLogoInHeader
    }, /*#__PURE__*/ React.createElement(CmsComponentSlot, {
        path: "Xpage container top"
    }), children, /*#__PURE__*/ React.createElement(CmsComponentSlot, {
        path: "Xpage container bottom"
    }));
};
function defaultRenderCartButton(item) {
    return /*#__PURE__*/ React.createElement(CartButton, {
        key: item.label,
        href: item.link && item.link.href,
        label: item.label,
        className: "header-menu__icon"
    });
}

export { CmsPageLayout, CmsPageLayout as default };
//# sourceMappingURL=Page.js.map
